import script from "./Interface.vue?vue&type=script&lang=ts&setup=true"
export * from "./Interface.vue?vue&type=script&lang=ts&setup=true"

import "./Interface.vue?vue&type=style&index=0&id=1a74c961&lang=css"

const __exports__ = script;

export default __exports__